import { render } from "./j-numbox.vue?vue&type=template&id=05f978bd&scoped=true"
import script from "./j-numbox.vue?vue&type=script&lang=js"
export * from "./j-numbox.vue?vue&type=script&lang=js"

import "./j-numbox.vue?vue&type=style&index=0&id=05f978bd&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f978bd"]])

export default __exports__